import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MetaStatus } from '@iotv/iotv-v3-types';
import { useTheme } from '@mui/material';
import { useContext } from 'react';
import { EntityNetworkSchematicContext } from '../context';
import { resolveIcon } from '../icons';
import { SchematicHandles } from './SchematicHandles';
import { SchematicIcon } from './SchematicIcon';
import { SchematicLabel } from './SchematicLabel';
import { SchematicNodeContainer } from './SchematicNodeContainer';
export const ValidBusinessObjectNode = ({ selected, data }) => {
    const theme = useTheme();
    const [context] = useContext(EntityNetworkSchematicContext);
    const resolvedIcon = resolveIcon(data.type, context);
    const { width, height } = resolvedIcon;
    const size = Math.min(width, height);
    const status = data.metadata?.status;
    if (status) {
        switch (status) {
            case MetaStatus.Normal:
                resolvedIcon.iconFill = theme.palette.info.dark;
                resolvedIcon.iconStroke = theme.palette.info.light;
                resolvedIcon.textFill = theme.palette.info.contrastText;
                resolvedIcon.textStroke = theme.palette.getContrastText(theme.palette.info.contrastText);
                break;
            case MetaStatus.Abnormal:
                resolvedIcon.iconFill = theme.palette.error.dark;
                resolvedIcon.iconStroke = theme.palette.error.light;
                resolvedIcon.textFill = theme.palette.error.contrastText;
                resolvedIcon.textStroke = theme.palette.getContrastText(theme.palette.error.contrastText);
                break;
        }
    }
    if (selected) {
        resolvedIcon.iconFill = theme.palette.primary.light;
        resolvedIcon.iconStroke = theme.palette.primary.dark;
    }
    return (_jsxs(SchematicNodeContainer, { width: width, height: height, rotation: data.rotation, children: [_jsx(SchematicIcon, { ...resolvedIcon, context: context }), _jsx(SchematicLabel, { size: size, rotation: data.rotation, colour: selected ? theme.palette.primary.dark : resolvedIcon.textFill, stroke: selected ? theme.palette.primary.contrastText : resolvedIcon.textStroke, text: data.name ?? data.sk, context: context }), _jsx(SchematicHandles, { context: context })] }));
};
